import React from 'react';
//import { CSSTransition } from 'react-transition-group';

import ConstantObject from '../Components/Constants';

import '../Styles/Social.css'

export default class textAlign extends React.Component {

  constructor(props) {
    super(props);
    console.log("align ....");
    //debugger;

    this.transitionEnd = this.transitionEnd.bind(this)
    this.mountStyle = this.mountStyle.bind(this)
    this.unMountStyle = this.unMountStyle.bind(this)
    this.state ={ //base css
      show: true,
      style :{
        fontSize: 60,
        opacity: 0,
        transition: 'all 2s ease',
      }
    }
  }

  handleClick(p) {
    //e.preventDefault();
//    debugger;
    //setTimeout(this.mountStyle, 10) // call the into animation
    //setTimeout(this.props.SetTextAlign(p), 500)
    this.props.SetTextAlign(p);
  }

  componentWillReceiveProps(newProps) { // check for the mounted props
    if(!newProps.mounted)
      return this.unMountStyle() // call outro animation when mounted prop is false
    this.setState({ // remount the node when the mounted prop is true
      show: true
    })
    setTimeout(this.mountStyle, 10) // call the into animation
  }

  unMountStyle() { // css for unmount animation
    this.setState({
      style: {
        fontSize: 60,
        opacity: 0,
        transition: 'all 1s ease',
      }
    })
  }

  mountStyle() { // css for mount animation
    this.setState({
      style: {
        fontSize: 60,
        opacity: 1,
        left: "55px",
        transition: 'left 0.7s ease, opacity 0.5s ease',
      }
    })
  }

  componentDidMount(){
    setTimeout(this.mountStyle, 10) // call the into animation
  }

  transitionEnd(){
    /*
    if(!this.props.mounted){ // remove the node on transition end when the mounted prop is false
      this.setState({
        show: false
      })
    }
    */
  }

/*<h1 style={this.state.style} onTransitionEnd={this.transitionEnd}>Hello</h1> */

  render () {
    console.log("ta render");
    console.log(this.props.textAlignArray);
    return (this.state.show &&
        <div className="scrolling-wrapper-flexbox" style={this.state.style} >
          {this.props.textAlignArray.map(item =>
            <a key={item.key} href="#" onClick={() => this.handleClick(item)}>
              <img className="card1" src={ConstantObject.quotes_img_sizes_root+item.url} alt={item.title} />
            </a>
          )}
        </div>
      )
  }

}
